const messages: Record<string, string> = {
    'c.importSuccess': '导入成功，共 {total} 条',
    'c.importPartSuccess': '部分导入成功：成功 {total} 条，失败 {failCount} 条',
};

export default messages;
